import { environment } from "src/environments/environment";

/**
 * dasa namespace contains all the classes used in dasa app
 */
export namespace dasa {

    export class DashboardReport {
        storeCount: number = 0;
        customerCount: number = 0;
        orderCount: number = 0;
        totalEarning: number = 0;
        driverCount: number = 0;
        businessCount: number = 0;
        userCount: number = 0;
    }

    export class ItemStoreRelation {
        itemId: number = -1;
        storeIds: number[] = [0];
    }

    export class QRCode {
        url: string = "";
        businessName: string = "";
        storeName: string = "";
        imageUrl: string = "";
        businessId: number = -1;
        storeId: number = -1;
    }

    /**
     * Business class
     */
    export class Business {
        id: number;
        businessAdminId: number;
        countryId: number;
        name: string;
        address: string;
        email: string;
        phone: string;
        status: number;
        logo: string;
        headerImage: string;
        createdOn: string;
        createdBy: number;
        modifiedOn: string;
        modifiedBy: number;

        constructor() {
            this.id = -1;
            this.businessAdminId = -1;
            this.countryId = -1;
            this.name = "";
            this.email = "";
            this.phone = "";
            this.status = Constant.STATUS_ENABLED;
            this.logo = "";
            this.headerImage = "";
            this.createdOn = "";
            this.createdBy = -1;
            this.modifiedOn = "";
            this.modifiedBy = -1;
            this.address = "";
        }
    }

    /**
     * User class
     */
    export class User {
        id: number;
        businessId: number;
        storeId: number;
        name: string;
        userGroupId: number;
        phone: string;
        email: string;
        password: string;
        gender: string;
        dob: string;
        pic: string;
        status: number;
        isPhoneVerified: boolean;
        isEmailVerified: boolean;
        createdOn: string;
        createdBy: number;
        modifiedOn: string;
        modifiedBy: number;

        constructor() {
            this.id = -1;
            this.businessId = -1;
            this.storeId = -1;
            this.name = "";
            this.userGroupId = -1;
            this.phone = "";
            this.email = "";
            this.password = "";
            this.gender = Constant.GENDER_MALE;
            this.dob = "";
            this.pic = "";
            this.isPhoneVerified = false;
            this.isEmailVerified = false;
            this.status = Constant.STATUS_ENABLED;
            this.createdOn = "";
            this.createdBy = -1;
            this.modifiedOn = "";
            this.modifiedBy = -1;
        }
    }

    /**
     * UserGroup class
     * All stakeHolder of dasa cms belongs to some UserGroup
     * Every UserGroup will have module wise authority
     */
    export class UserGroup {
        id: number;
        name: string;
        constructor() {
            this.id = -1;
            this.name = "";
        }
    }

    /**
     * Authority class
     * UserGroup's modulewise authority will decide that which module an user can access and at which level
     */
    export class Authority {
        id: number;
        name: string;
        constructor() {
            this.id = -1;
            this.name = "";
        }
    }

    /**
     * Module class
     */
    export class Module {
        id: number;
        name: string;
        constructor() {
            this.id = -1;
            this.name = ""
        }
    }

    /**
     * GroupAuthorization class
     */
    export class GroupAuthorization {
        id: number;
        storeId: number;
        moduleId: number;
        userGroupId: number;
        authorityId: number;

        constructor() {
            this.id = -1;
            this.storeId = -1;
            this.moduleId = -1;
            this.userGroupId = -1;
            this.authorityId = -1;
        }
    }

    export class Customer {
        id = -1;
        businessId = -1;
        storeId = -1;
        name = "";
        email = "";
        phone = "";
        gender = Constant.GENDER_MALE;
        dob = "";
        password: string = "";
        pic: string = "";
        googleToken: string = "";
        facebookToken: string = "";
        stripToken: string = "";
        status: Number = Constant.STATUS_ENABLED;
        isMobileVerified: Number = Constant.IS_MOBILE_VERIFIED_NO;
        isEmailVerified: Number = Constant.IS_EMAIL_VERIFIED_NO;
        deliveryAddresses: DeliveryAddress[] = [] as DeliveryAddress[];
        isSocialUser: number = Constant.SOCIAL_USER_NO;
        type: number = -1;
    }

    export class DeliveryAddress {
        indexId: Number = -1;
        personName: string = "";
        personMobile: string = "";
        houseNumber: string = "";
        streatAddress: string = "";
        address: string = "";
        longitude: string = "";
        latitude: string = "";
        pincode: string = "";
        deliveryNote: string = "";
    }

    export class Country {
        id: number;
        code: string;
        name: string;
        isd: string;
        currency: string;
        currencySymbol: string;

        constructor() {
            this.id = -1;
            this.code = "";
            this.name = "";
            this.isd = "";
            this.currency = "";
            this.currencySymbol = "";
        }
    }

    /**
     * Store Model Class uses to save and fetch store object
     */
    export class Store {
        id: number = -1;
        businessId: number = -1;
        storeAdminId: number = -1;
        deliveryType: number = Constant.DELIVERY_TYPE_PICKUP_DELIVERY_BOTH;
        name: String = "";
        email: String = "";
        phone: String = "";
        address: String = "";
        longitude: String = "";
        latitude: String = "";
        banner: String = "";
        description: String = "";
        adminCommision: String = "";
        defaultTax: String = "";
        isFeatured: number = Constant.FEATURED_STORE_NO;
        status: number = Constant.STATUS_ENABLED;
        vromoStoreId: String = "";
        createdBy: number = -1;
        createdOn: String = "";
        modifiedBy: number = -1;
        modifiedOn: String = "";
    }

    export class selectedStoreDetails {
        id: number = -1;
        businessId: number = -1;
        storeAdminId: number = -1;
        deliveryType: number = Constant.DELIVERY_TYPE_PICKUP_DELIVERY_BOTH;
        name: String = "";
        email: String = "";
        phone: String = "";
        address: String = "";
        longitude: String = "";
        latitude: String = "";
        banner: String = "";
        description: String = "";
        adminCommision: String = "";
        defaultTax: String = "";
        isFeatured: number = Constant.FEATURED_STORE_NO;
        status: number = Constant.STATUS_ENABLED;
        vromoStoreId: String = "";
        createdBy: number = -1;
        createdOn: String = "";
        modifiedBy: number = -1;
        modifiedOn: String = "";
    }

    /**
     *	TimingJson
     */
    export class TimingJson {
        day: string = "";
        openingTime: string = "";
        closingTime: string = "";
    }

    /**
     *	DeliveryRange
     */
    export class DeliveryRange {
        startRange: string = "";
        endRange: string = "";
        deliveryTime: string = "";
    }

    /**
     *	Brand
     */
    export class Brand {
        id: number = -1;
        businessId: number = -1;
        storeId: number = -1;
        name: string = "";
        pic: string = "";
        createdBy: number = -1;
        createdOn: string = "";
        modifiedBy: number = -1;
        modifiedOn: string = "";
    }

    /**
      *	Category
      */
    export class Category {
        id: number = -1;
        businessId: number = -1;
        storeId: number = -1;
        name: string = "";
        pic: string = "";
        createdBy: number = -1;
        createdOn: string = "";
        modifiedBy: number = -1;
        modifiedOn: string = "";
    }

    /**
     *	BankDetail
     */
    export class BankDetail {
        id: number = -1;
        businessId: number = -1;
        storeId: number = -1;
        name: string = "";
        bankName: string = "";
        ifscCode: string = "";
        accountNo: string = "";
        note: string = "";
        isVerified: number = -1;
        createdBy: number = -1;
        createdOn: string = "";
        modifiedBy: number = -1;
        modifiedOn: string = "";
    }

    /**
     * Class CMS
     */
    export class CMS {
        id: number = -1;
        type: number = Constant.CMS_TYPE_STORE;
        page: string = "";
        content: string = "";
        createdBy: number = -1;
        createdOn: string = "";
        modifiedBy: number = -1;
        modifiedOn: string = "";
    }

    /**
     * Class use to save and fetch store setting from database
     */
    export class StoreSettings {
        id: number = -1;
        storeId: number = -1;
        status: number = -1;
        storeDiscount: String = "";
        dRangeJson: DeliveryRange[] = [];
        timingJson: TimingJson[] = [];
        minOrderAmount: string = "";
        createdBy: number = -1;
        createdOn: string = "";
        modifiedBy: number = -1;
        modifiedOn: string = "";
        disabledBrandIds: number[] = [];
        disabledCategoryIds: number[] = [];
        disabledItemIds = [0];
        scheduledOrders: boolean = false;
        deliveryCostType: number = 0;
    }

    export class OrderStatusHistory {
        id: number = -1;
        orderId: number = -1;
        status: number = -1;
        updatedOn: string = "";
        updatedBy: number = -1;
        note: string = "";
    }

    export class Order {
        id: number = -1;
        businessId: number = -1;
        storeId: number = -1;
        customerId: number = -1;
        carts: Cart[] = [] as dasa.Cart[];
        totalPrice: number = 0.0;
        totalExtraPrice: number = 0.0;
        totalDiscount: number = 0.0;
        netPayable: number = 0.0;
        deliveryCharges: number = 0;
        deliveryAddress: DeliveryAddress = {} as DeliveryAddress;
        status: number = Constant.ORDER_TYPE_PENDING;
        createdBy: number = -1;
        createdOn: string = "";
        orderStatusHistory: OrderStatusHistory[] = [] as OrderStatusHistory[];
        // fields that are missing in db call
        // paymentType: number = Constant.PAYMENT_TYPE_CASH_ON_DELIVERY;
        paymentType: number = Constant.PAYMENT_TYPE_PAY_ONLINE;
        tax: number = 0.0;
        modifiedBy: number = -1;
        modifiedOn: string = "";
        // deliveryType: number = Constant.DELIVERY_TYPE_DELIVERY_ONLY;
        deliveryType: number = 0;
        // Channel the order came in through — 1=Online, 2=Catering,
        // 3=In-Store (POS), 4=Mobile App. Populated by the backend; the
        // customer app reads it to label the order source on order-detail
        // and my-orders. Optional because older cached orders may not
        // carry it.
        orderType?: number;
        deliveryNote: string = "";
        customer: Customer = {} as Customer;
        transactionId: string = "";
        paymentId: number = -1;
        trackingUrl = "";
        pickupTime: string = "";
        pandaOrderId = "";
        pandaOrderDetail: PandaOrderResponse = {} as PandaOrderResponse;
        lastUpdatedFromPanda = "";
        // option
        totalOptionPrice: number = 0;
        promoCode: string = '';
        discountONPromo: number = 0;
        isPromoCodeAvailed: boolean = false;
        priceBeforePromo : number = 0;
        priceAfterPromo : number = 0;
        scheduled: boolean = false;
        scheduledDateTime: string = '';
        guest: boolean = false;
        guestObj: any = null;
        mobile: boolean = false;
        web : boolean = true;
        pos: boolean = false;
        deliveryFee: number = 0;

        // Cashback settling part of this bill. Applied at ORDER level, after
        // tax and after any promo — it's a voucher paying the bill, not a
        // price reduction, so it never touches line prices or tax.
        //
        // Deliberately NOT Cart.isReward/rewardId: those belong to the
        // stamps programme's £0 free-item redemption, and reusing them would
        // drag cashback into every downstream isReward consumer.
        cashbackRedeemed: number = 0;
        // Handle to the balance hold taken at checkout. Confirmed server-side
        // once payment succeeds; released if the customer never pays.
        cashbackReservationRef: string | null = null;
        // What this order earned. Set by the backend, read for display only.
        cashbackEarned?: number;
    }

    /** What the customer may put on the current basket, and why not if they can't. */
    export interface CashbackQuote {
        eligible: boolean;
        /** MODE_OFF | CHANNEL_OFF | NOT_SIGNED_IN | BELOW_MIN_ORDER | BELOW_MIN_BALANCE | NO_BALANCE | OK */
        reasonCode: string;
        /** Safe to show as-is when not eligible. */
        message?: string;
        maxRedeemable: number;
        balance: number;
        estimatedEarn: number;
        shortfallToMinOrder?: number;
        shortfallToMinBalance?: number;
        earnPercent?: number;
    }

    /** A held redemption. Apply approvedAmount, never what was requested. */
    export interface CashbackReservation {
        success: boolean;
        reservationRef: string;
        approvedAmount: number;
        balanceAfter: number;
        clamped: boolean;
        message?: string;
    }

    export interface CashbackBalance {
        businessId: number;
        customerId: number;
        balance: number;
        lifetimeEarned: number;
        lifetimeRedeemed: number;
        lifetimeExpired: number;
        nextExpiry?: string;
        expiringSoon: number;
        loyaltyMode?: string;
    }

    export interface CashbackLedgerEntry {
        id: number;
        entryType: string;
        amount: number;
        orderId?: number;
        channel?: number;
        status: string;
        createdOn: string;
        expiresOn?: string;
        note?: string;
        /** Plain-English label, so every screen doesn't remap entryType. */
        label: string;
    }

    export class PandaOrderResponse {
        order_id = "";
        sender: Sender = {} as Sender;
        recipient: Receiver = {} as Receiver;
        payment_method = "";
        coldbag_needed = false;
        amount = 0;
        description = "";
        status = "";
        delivery_fee = 0;
        timeline: Timeline = {} as Timeline;
        driver: Driver = {} as Driver;
        created_at = -1;
        updated_at = -1;
        tracking_link = "";
        proof_of_delivery_url = "";
    }

    export class Driver {
        id = "";
        name = "";
        phone_number = "";
    }

    export class Timeline {
        estimated_pickup_time = "";
        estimated_delivery_time = "";
    }

    export class Receiver {
        name = "";
        phone_number = "";
        location = null;
        notes = "";
    }

    export class Sender {
        name = "";
        phone_number = "";
        location = null;
        notes = "";
    }

    /**
     * PaymentData
     */
    export class PaymentData {
        amount: number = 0;
        businessId: number = -1;
        storeId: number = -1;
        customerId: number = -1;
        paymentDataFromDevice: string = "";
        paymentMethodNounce: string = "";
        currency: string = "";
        sourceId: string = "";
        locationId: string = "";
        idemPotencyKey: string = "";
    }

    export class DeliveryCharge {
        estimated_delivery_fee = 0;
    }

    /**
     * Constant class contain all the constant
     */
    export class Constant {
        public static SOCIAL_USER_YES = 1;
        public static SOCIAL_USER_NO = 2;
        public static GOOGLE_USER = 1;
        public static FACEBOOK_USER = 2;
        public static MICROSOFT_USER = 3;

        public static FEEDBACK_TYPE_SUGGESTION = 1;
        public static FEEDBACK_TYPE_COMPLAIN = 2;
        public static FEEDBACK_TYPE_FEEDBACK = 3;

        public static FEEDBACK_STATUS_OPEN = 1;
        public static FEEDBACK_STATUS_CLOSED = 2;

        public static readonly PAYMENT_TYPE_PAY_ONLINE = 1;
        public static readonly PAYMENT_TYPE_CASH_ON_DELIVERY = 2;
        // On-account (Net-X credit) — catering only. The order is placed
        // unpaid and settled by the monthly invoice job. Gated server-side
        // by CateringCreditService (approved + within credit limit).
        public static readonly PAYMENT_TYPE_ON_ACCOUNT = 3;

        public static readonly IS_MOBILE_VERIFIED_YES = 1;
        public static readonly IS_MOBILE_VERIFIED_NO = 2;

        public static readonly IS_EMAIL_VERIFIED_YES = 1;
        public static readonly IS_EMAIL_VERIFIED_NO = 2;

        public static readonly DATE_TIME_FORMAT: string = "yyyy-MM-dd HH:mm:ss";
        public static readonly DISPLAY_DATE_TIME_FORMAT: string = "yyyy-MM-dd HH:mm";
        public static readonly DATE_SORT_FORMAT: string = "yyyy-MM-dd";

        public static readonly STATUS_ENABLED: number = 1;
        public static readonly STATUS_DISABLED: number = 2;

        public static readonly GENDER_MALE = "M";
        public static readonly GENDER_FEMALE = "F";
        public static readonly GENDER_TRANSGENDER = "T";

        public static readonly ACCESS_TYPE_NO_ACCESS: number = 1;
        public static readonly ACCESS_TYPE_READ_ONLY: number = 2;
        public static readonly ACCESS_TYPE_READ_WRITE: number = 3;

        public static readonly USER_TYPE_SUPER_ADMIN: number = 1;
        public static readonly USER_TYPE_BUSINESS_ADMIN: number = 2;
        public static readonly USER_TYPE_STORE_ADMIN: number = 3;
        public static readonly USER_TYPE_DRIVER: number = 4;
        public static readonly USER_TYPE_BUSINESS_ADMIN_cum_STORE_ADMIN: number = 5;
        public static readonly USER_TYPE_KITCHEN_USER: number = 6;

        public static readonly DELIVERY_TYPE_PICK_UP_ONLY: number = 1;
        public static readonly DELIVERY_TYPE_DELIVERY_ONLY: number = 2;
        public static readonly DELIVERY_TYPE_PICKUP_DELIVERY_BOTH: number = 3;

        // Cart / platform types — match the backend's platformType column on Order
        // and Kleftiko iOS's cartType (Utility.cartType). Catering uses 2 across
        // every API call so the existing /api/orders/add endpoint routes correctly.
        // ON_DEMAND aligns with the default Utility.cartType value.
        public static readonly CART_TYPE_ON_DEMAND: number = 1;
        public static readonly CART_TYPE_CATERING: number = 2;
        public static readonly PLATFORM_TYPE_CATERING: number = 2;

        public static readonly FEATURED_STORE_YES: number = 1;
        public static readonly FEATURED_STORE_NO: number = 2;

        public static readonly DISCOUNT_TYPE_PERCENT: number = 1;
        public static readonly DISCOUNT_TYPE_FLAT: number = 2;

        // Image streaming URL — served by the new backend image controller.
        public static readonly FILE_STREAM_URL = environment.FILE_STREAM_URL;

        public static readonly ACTION_TYPE_LOGIN_OK = "loginOk";
        public static readonly ACTION_TYPE_ADD_USER_OK = "addUserOk";

        public static readonly ACTION_TYPE_CHECK_PHONE_NUMBER_VALID= "isPhoneNumberValidOk";

        public static readonly ACTION_TYPE_ADD_BUSINESS_OK = "addBusinessOk";
        public static readonly ACTION_TYPE_EDIT_PROFILE_OK = "editProfileOk";
        public static readonly ACTION_TYPE_LOGOUT_OK = "logoutOk";
        public static readonly ACTION_TYPE_CHANGE_PASSWORD_OK = "changePasswordOk";

        public static readonly ACTION_TYPE_ADD_SUPPORT_OK = "addSupportOk";
        public static readonly ACTION_TYPE_GET_SUPPORTS_OK = "getSupportsOk";
        public static readonly ACTION_TYPE_DELETE_SUPPORT_OK = "deleteSupportOk";
        public static readonly ACTION_TYPE_GET_SUPPORT_BUSINESS = "getSupportsForBusiness";

        public static readonly ACTION_TYPE_GET_BUSINESS_SETTING = "getBusinessSettingOk";
        public static readonly ACTION_TYPE_ADD_STORE_OK = "addStoreOk";
        public static readonly ACTION_TYPE_ADD_STORE_ADMIN_OK = "addStoreAdminOk";

        public static readonly ACTION_TYPE_ADD_STORE_PREFERENCES_OK: string = "addStorePreferencesOk";
        public static readonly ACTION_TYPE_GET_STORE_PREFERENCES: string = "getStorePreferencesOk";

        public static readonly ACTION_TYPE_EDIT_CMS_OK: string = "editCmsOk";
        public static readonly ACTION_TYPE_GET_ALL_CMS: string = "getAllCmsOk";

        public static readonly ACTION_TYPE_GET_DRIVERS_OK = "getDriversOk";
        public static readonly ACTION_TYPE_ADD_DRIVERS_OK = "addEditDriverOk";

        public static readonly ACTION_TYPE_ADD_BANK_DETAIL_OK = "addBankDetailOk";
        public static readonly ACTION_TYPE_GET_BANK_DETAIL_OK = "getBankDetailOk";

        public static readonly ACTION_TYPE_ADD_BRAND_OK = "addBrandOk";
        public static readonly ACTION_TYPE_GET_BRANDS_OK = "getBrandsOk";

        public static readonly ACTION_TYPE_ADD_CATEGORY_OK = "addCategoryOk";
        public static readonly ACTION_TYPE_GET_CATEGORY_OK = "getCategoriesOk";

        public static readonly ACTION_TYPE_ADD_STORE_ITEM_OK = "addStoreItemOk";
        public static readonly ACTION_TYPE_GET_STORE_ITEM_OK = "getStoreItemOk";

        public static readonly ACTION_TYPE_ADD_EXTRA_OK = "addExtraOk";
        public static readonly ACTION_TYPE_GET_EXTRA_OK = "getExtraOk";

        public static readonly ACTION_TYPE_GET_BUSINESS_BY_ID = "getBusinessById";

        public static readonly ACTION_TYPE_ADD_ITEM_EXTRA_RELATION_OK = "addItemExtraRelationOk";
        public static readonly ACTION_TYPE_GET_EXTRAS_BY_ITEMID_OK = "getExtrasByItemId";
        public static readonly ACTION_TYPE_GET_MY_STORE_SETTING = "getMySoreSettingOk";

        public static readonly ACTION_TYPE_ADD_BUSINESS_ITEM_OK = "addBusinessItemOk";
        public static readonly ACTION_TYPE_GET_BUSINESS_ITEM_OK = "getBusinessItemOk";
        public static readonly ACTION_TYPE_GET_CMS_BY_ID = "getCmsById";
        public static readonly ACTION_TYPE_GET_DASHBOARD_REPORT = "getDashboardReport";
        public static readonly ACTION_TYPE_ADD_BUSINESS_ITEM_TO_STORE = "addBusinessItemToStore";
        public static readonly ACTION_TYPE_GENERATE_QR_CODE = "generateQRCode";

        public static readonly ACTION_TYPE_GET_POS_SETTINGS = "getPosSetting";
        public static readonly ACTION_TYPE_GET_POS_SETTINGS_FOR_STORE = "getPosSettingForStore";

        public static readonly ACTION_TYPE_ADD_EDIT_CUSTOMER_OK = "addEditCustomerOk";
        public static readonly ACTION_TYPE_CUSTOMER_LOGIN_OK = "customerLoginOk";
        public static readonly ACTION_TYPE_ADD_EDIT_ORDER_OK = "addEditOrderOk";
        public static readonly ACTION_TYPE_CHANGE_STATUS_OF_AN_ORDER = "changeStatusOfAnOrder";

        public static readonly ACTION_TYPE_ADD_DELIVERY_ADDRESS_OK = "addDeliveryAddressOk";
        public static readonly ACTION_TYPE_DELETE_DELIVERY_ADDRESS_OK = "deleteDeliveryAddressOk";
        public static readonly ACTION_TYPE_GET_MY_ORDER = "getMyOrder";
        public static readonly ACTION_TYPE_GET_ORDER_FOR_STORE = "getOrderForStore";
        public static readonly ACTION_TYPE_MAKE_PAYMENT_OK = "makePaymentOk";

        public static readonly ACTION_TYPE_ADD_COMPLAIN_FEEDBACK_OK = "addEditComplainFeedbackOk";
        public static readonly ACTION_TYPE_GET_COMPLAIN_FEEDBACK_OK = "getComplainFeedbackForCustomer";
        public static readonly ACTION_TYPE_ADD_CONVERSATION_OK = "addEditConversationOk";
        public static readonly ACTION_TYPE_CREATE_PAYMENT_FROM_SQUAREUP: string = "getCreatePaymentFromSquareup";
        public static readonly ACTION_TYPE_RECOVER_PASSWORD_OK = "recoverPasswordOk";
        public static readonly ACTION_TYPE_CREATE_PAYMENT_FROM_STRIPE = "getCreatePaymentFromStripe";

        public static readonly ACTION_TYPE_GET_UI_SETTINGS = "getUiSettingsOk";
        public static readonly ACTION_TYPE_VERIFY_PROMO_CODE = "validatePromoCode";
        public static readonly ACTION_TYPE_GET_DELIVERY_ADDRESS = "getDeliveryAddresses";
        public static readonly REDEEM_PROMO_SUCCESS = "redeemPromoSuccess";
        public static readonly FREE_DELIVERY_PROMO = "freeDeliveryPromo";
        public static readonly VERIFY_EMAIL_ADDRESS = "emailCheck";
        public static readonly ADD_GUEST_INFO = "addGuestInfo";
        public static readonly GET_ORDER_BY_ID = "getOrderById";

        public static ORDER_TYPE_PENDING = 1;
        public static ORDER_TYPE_ACCEPTED = 2;
        public static ORDER_TYPE_REJECTED = 3;
        public static ORDER_TYPE_PROCESSING = 4;
        public static ORDER_TYPE_CANCELED = 5;
        public static ORDER_TYPE_PICKED = 6;
        public static ORDER_TYPE_DELIVERED = 7;
        public static ORDER_TYPE_READY_FOR_PICKUP = 8;
        public static ORDER_TYPE_OUT_FOR_DELIVERY = 9;
        public static ORDER_TYPE_SEARCHING_FOR_COURIER = 11;
        public static ORDER_TYPE_COURIER_ASSIGNED = 12;
        public static ORDER_TYPE_COURIER_ARRIVING_PICKUP = 13;
        public static ORDER_TYPE_CUSTOMER_DROPOFF_IMMINENT = 14;
        public static ORDER_TYPE_SCHEDULE_ACCEPTED = 24;
        public static ORDER_TYPE_CANCELLED_BY_VENDOR = 25;
        public static ORDER_TYPE_CANCELLED_BY_CUSTOMER = 26;

        public static readonly CMS_TYPE_DRIVER: number = 1;
        public static readonly CMS_TYPE_STORE: number = 2;
        public static readonly CMS_TYPE_CUSTOMER: number = 3;

        public static readonly ACTION_TYPE_GET_ORDER_DETAIL_FROM_PANDA = "getOrderDetailFromPanda";
        public static readonly ACTION_TYPE_GET_DELIVERY_ESTIMATION = "getDeliveryEstimation";

        public static readonly ACTION_TYPE_GET_OPTION_SET_BY_ID_OK = "getOptionSetByItemIdOk";
        public static readonly ACTION_TYPE_GET_ALL_B1G1_FREE_PROMO = "getAllB1G1FreePromos";
        public static readonly ACTION_TYPE_GET_ACTIVE_B1G1_FREE_PROMO = "getActiveB1G1FreePromos";
    }

    // option start
    export class Option {
        id: number = -1;
        optionSetId: number = -1;
        name: string = "";
        price: number = -1;
        image: any;
        status: number = -1;
        displayOrder: number = -1;
        json: any = [];
        quantity = 0;
    }
    // option ends

    // ui setting start
    export class UISettings {
        id: number = -1;
        storeId: number = -1;
        businessId: number = -1;
        createdBy = -1;
        header: string = "#034131";
        footer: string = "#241C15";
        primaryColor: string = "#d8eacc";
        secondaryColor: string = "#ffffff";
        buttonSaveOk: string = "#00046B";
        cancelButton: string = "#dc3545";
        leftNavigationButton: string = "#ffffff";
        categoryButton: string = "#deb887";
        checkOutColor: string = "#25F6AF";
        bodyText: string = "#000000";
        // Surface tokens — card borders/dividers and secondary text. Added so a
        // themed store no longer keeps fixed greys on the catering and dining
        // adventure screens.
        borderColor: string = "#e5e7eb";
        mutedTextColor: string = "#374151";
        // Page banner (screen title block) and the sticky menu/search bar.
        // Independently themable from the site header.
        pageBannerColor: string = "#ffffff";
        menuBarColor: string = "#034131";
        // Catering menu grid density on wide screens. 3 matches the previous
        // auto-fill layout at desktop widths.
        cateringItemsPerRow: number = 3;
        // Accent/surface tokens for the booking flow.
        accentColor: string = "";
        accentContrastColor: string = "";
        priceColor: string = "";
        surfaceColor: string = "";
        headingTextColor: string = "";
        /**
         * Per-page colour overrides plus every token added from here on,
         * including the foreground ("...TextColor") colours that make dark
         * backgrounds usable. Shape:
         *   { general:{...}, ordering:{...}, reservation:{...}, catering:{...} }
         * A page stores only what it overrides; the rest inherits.
         */
        pageThemesJson: string = "";
        buttonSuccess: string = "#00046B";
        buttonWarning: string = "#f7b900";
        buttonDanger: string = "#dc3545";
    }
    // ui setting ends

    /*get extra data*/
    export class extra {
        id: number = -1;
        businessId: number = -1;
        storeId: number = -1;
        name: string = "";
        pic: string = "";
        price: number = 0.0;
        note: string = "";
        createdBy: number = -1;
        createdOn: string = "";
        modifiedBy: number = -1;
        modifiedOn: string = "";
        quantity: number = 0;
    }

    export class Cart {
        storeItem: StoreItem = {} as StoreItem;
        quantity: number = 0;
        price: number = 0.0;
        extraPrice: number = 0.0;
        tax: number = 0.0;
        discount: number = 0.0;
        netPayable: number = 0.0;
        optionPrice: number = 0.0;
        isB1G1: boolean =false
        isReward: boolean =false;
        rewardId:number = 0;
        orderNotes: String = '';
        voided: boolean =false;
        uuid: String = '';
        sentToKitchen: boolean =false;
        serviceChargeApplied: boolean =false;
        /**
         * Stage 3 — catering platter size variant. Optional; only set when
         * the customer picks a size on the Catering Management menu (e.g.
         * "L"). Serialized into Order.cartJson so the kitchen-report
         * aggregator (Stage 4) can explode each line's components.
         */
        sizeCode?: string;
        /** Artwork the customer uploaded for this line (ecommerce stores that take it). */
        artworkToken?: string;
        artworkName?: string;
    }

    /**
     * For all Support detail related purpose
     */
    export class SupportDetail {
        id: number = -1;
        location: string = "";
        email: string = "";
        phone: string = "";
        note: string = "";
        createdBy: number = -1;
        createdOn: string = "";
        modifiedBy: number = -1;
        modifiedOn: string = "";
        constructor() { }
    }

    /*
    for adding store items
    */
    export class StoreItem {
        id: number = -1;
        brandId: number = -1;
        categoryId: number = -1;
        businessId: number = -1;
        storeId: number = -1;
        name: String = "";
        pic: String = "";
        price: number = 0.0;
        unitId: number = -1;
        discountType = Constant.DISCOUNT_TYPE_FLAT;
        discountedAmount: number = 0.0;
        tax: number = 0.0;
        billAmount: number = 0.0;
        ingredients: String = "";
        description: String = "";
        preparationTime: String = "";
        additionalInfo: String = "";
        dailyCapacity: number = -1;
        createdBy: number = -1;
        createdOn: String = "";
        modifiedBy: number = -1;
        modifiedOn: String = "";
        extras: any = [];
        // optionSets: any = [];
        optionSets: OptionSet[] = {} as OptionSet[];
        quantity: number = 0;
        /** Dietary / allergen marks as stored short codes — "V,GF". */
        dietaryTags: string | null = null;
        /**
         * Whether the item is inside its availability window, decided by the
         * server so the day/time rules and the store's timezone live in one
         * place. Null means "not evaluated" — an unscheduled store, or an
         * older backend — and must read as available.
         */
        availableNow: boolean | null = null;
        /** e.g. "Available tomorrow from 06:00". Null when it's available. */
        availabilityLabel: string | null = null;
    }

    export class OptionSet {
        id: number = -1;
        name: string = "";
        itemId: number = -1;
        status: number = -1;
        displayOrder: number = -1;
        condition: number = -1;
        json: any = [];
        variantName: string = "";
        variantType: number = 0;
        options: any = [];
    }

    export class ExtraItemRelation {
        id: number = -1;
        itemId: number = -1;
        createdBy: number = -1;
        extraIds: number[] = [];
        extras: any = [];
    }

    export class PosSetting {
        business: Business = {} as Business;
        stores: Store[] = [] as Store[];
        storeSettings: StoreSettings = {} as StoreSettings;
        brands: Brand[] = [] as Brand[];
        categories: Category[] = [] as Category[];
        storeItems: StoreItem[] = [] as StoreItem[];
        //	ArrayList<Extra> extras = null;
        country: Country = {} as Country;
    }

    /**
     * Class used to create an object of FeedbackComplain
     */
    export class FeedbackComplain {
        id: number = -1;
        businessId: number = -1;
        storeId: number = -1;
        customerId: number = -1;
        type: number = -1;
        subject: string = "";
        content: string = "";
        status: number = Constant.FEEDBACK_STATUS_OPEN;
        dateTime: string = "";
        lastRespondedOn: string = "";
        conversations: FeedbackComplainConversation[] = [] as FeedbackComplainConversation[];
    }

    /**
     * Class Used to create an Object of FeedbackComplainConversation
     */
    export class FeedbackComplainConversation {
        id: number = -1;
        complainId: number = -1;
        content: string = "";
        customerId: number = -1;
        respondedBy: number = -1;
        status: number = Constant.FEEDBACK_STATUS_OPEN;
        dateTime: string = "";
    }

    /**
     * For all request made on server, we have to pass json of RequestObject
     */
    export class RequestObject {
        command: string = "";
        businessId: number = -1;
        storeId: number = -1;
        loggedUserId: number = -1;
        customer: Customer = {} as Customer;
        order: Order = {} as Order;
        customerId: number = -1;
        // indexId: number = -1;
        deliveryAddress: DeliveryAddress = {} as DeliveryAddress;

        paymentData: PaymentData = {} as PaymentData;
        supportDetail: SupportDetail = {} as SupportDetail;

        feedbackComplain: FeedbackComplain = {} as FeedbackComplain;
        conversation: FeedbackComplainConversation = {} as FeedbackComplainConversation;

        appType = "";
        email = "";
        orderStatus: OrderStatusHistory = {} as OrderStatusHistory;

        orderId = -1;
        pandaOrderId = "";

        itemId: number = -1;

        phoneNumber: String = "";
        promoCodes: any;
        priceBeforePromo: Number = 0;
        priceAfterPromo: Number = 0;
        cartSize = 0;
        currentDate:String = "";
        payment_intent_client_secret: String = "";

    }

    export class MyStoreSetting {
        users: User[] = [];
        stores: Store[] = [];
        storeSettings: any = {};
        brands: Brand[] = [];
        categories: Category[] = [];
        storeItems: StoreItem[] = [];
    }

    export class B1G1FreePromo{
      id:number = 0;
      promoCodesId:number = 0;
      active: boolean = false;
      code:string ="";
      promoItems: StoreItem[] = [];
      startDate:string ="";
      endDate:string ="";
      storeId:number = 0;

    }


    /**     * For each request made, server will respond with ResponseObject     */
    export class ResponseObject {
        command: string = "";
        success: boolean = true;
        message: string = "";
        posSettings: PosSetting = {} as PosSetting;
        customer: Customer = {} as Customer;
        order: Order = {} as Order;
        orders: Order[] = [] as Order[];
        orderStatusHistories: OrderStatusHistory[] = [] as OrderStatusHistory[];
        deliveryAddress: dasa.DeliveryAddress = {} as DeliveryAddress;

        feedbackComplain: FeedbackComplain = {} as FeedbackComplain;
        conversation: FeedbackComplainConversation = {} as FeedbackComplainConversation;
        feedbackComplains: FeedbackComplain[] = [] as FeedbackComplain[];
        paymentResponseJson: string = '{}';
        paymentId: number = -1;
        deliveryCharge: DeliveryCharge = {} as DeliveryCharge;
        pandaOrderDetail: PandaOrderResponse = {} as PandaOrderResponse;
        promoCodes: any;
        errorMessage: string="";
        B1G1FreePromoCode: B1G1FreePromo = {} as B1G1FreePromo;
        b1g1FreePromoList: any = [];
    }

    /**     * Utility class      */
    export class Utility {
        public static loggedInUser: Customer = {} as Customer;
        public static selectedStoreId: number = -1;
        public static selectedBusinessId: number = -1;
        public static busyDivObject: any = {};

        public static uiSettings: UISettings = {} as UISettings;

        public static business: Business = {} as Business;
        public static stores: Store[] = [] as Store[];
        public static selectedStoreDetails: selectedStoreDetails[] = [] as selectedStoreDetails[];
        public static storeSettings: StoreSettings = {} as StoreSettings;
        public static brands: Brand[] = [] as Brand[];
        public static categories: Category[] = [] as Category[];
        public static storeItems: StoreItem[] = [] as StoreItem[];
        public static country: Country = {} as Country;
        public static carts: Cart[] = [] as Cart[];
        public static storeOrders: Order[] = [] as Order[];
        public static previousRoute = "";

        public static supportDetails: any = [];

        public static complains: FeedbackComplain[] = [] as FeedbackComplain[];

        public static temporaryOrderRequest: RequestObject = {} as RequestObject;
        public static promoCodeDetail: any;
        public static b1g1FreePromoList: B1G1FreePromo[] =[];
        public static selectedBrandId: number = -1;
        public static storeConfigurations : StoreConfiguration = {} as StoreConfiguration;
        public static addPoints: AddPoints = {} as AddPoints;
        /**
         * Kleftiko parity: 1 = regular on-demand ordering (default),
         * 2 = catering. Set by DiningAdventure mode selector; consumed by
         * storeitems (menu fetch) and placeorder (forced delivery + forced
         * scheduled + prep time). Constants live on dasa.Constant.
         */
        public static cartType: number = 1;
        /**
                * Used to show spinner
                */
        public static showBusy(): void {
            this.busyDivObject.style.display = '';
        }
        /**
         * Used to hide spinner
         */
        public static hideBusy(): void {
            this.busyDivObject.style.display = 'none';
        }
    }

    export class ChangePassword {
        userId: number = -1;
        oldPassword: string = '';
        newPassword: string = '';
        modifiedBy: number = -1;

        constructor() {
            // this.userId = -1;
            // this.oldPassword = "";
            // this.newPassword = "";
            // this.modifiedBy = -1;
        }
    }
    // models/response-object.ts
export interface NewResponseObject<T> {
    success: boolean;
    message: string;
    data: T;
    statusCode: number;
  }
  
  // models/promo-code.ts
  export interface PromoCode {
    id: number;
    code: string;
    type: number;
    active: boolean;
    value: number;
    minimumCartSize: number;
    startDate: string;
    endDate?: string | null;
    businessId: number;
    storeId: number;
    maxRedemptions: number;
    totalRedeemed: number;
  }

export interface StoreConfiguration {
  id?: number;
  businessId?: number;
  storeId?: number;
  vatNumber?: string;

  /**
   * The store's own WhatsApp-reachable number (Store Configurations →
   * "Contact Mobile (WhatsApp)"), in E.164 or local form. When set, the
   * customer-facing help widget messages the STORE rather than DASA support —
   * a customer asking about their order wants the restaurant, not us.
   */
  contactMobile?: string;

  // POS / channels
  posEnabled?: boolean;
  mposEnabled?: boolean;
  sync?: boolean;
  onlineOrderingEnabled?: boolean;
  dposOnlineOrderingEnabled?: boolean;
  kitchenDisplaySystem?: boolean;
  mobileAppsEnabled?: boolean;

  // Features
  /**
   * Whether this store's menus show dietary marks and the allergen panel.
   *
   * Vendor portal -> Store Configurations -> Services. undefined / true =
   * shown, which is what every store predating the setting is doing, so the
   * customer app must treat only an explicit false as off. See
   * dietaryDisplayEnabled() in customer/common/dietary-tags/dietary-display.
   */
  showDietaryInfo?: boolean;

  cateringEnabled?: boolean;
  /**
   * Phase 0 catering-management feature flag. When true, the customer
   * sees the richer Catering Management page (/catering/*)
   * instead of the Kleftiko-style /dining-adventure selector.
   * Default false — opt-in per store.
   */
  cateringManagementEnabled?: boolean;
  reservationsEnabled?: boolean;
  loyaltyEnabled?: boolean;
  quickService?: boolean;
  hoursTracking?: boolean;

  // Service charge
  serviceChargePercentage?: number;
  serviceChargeEnabledDefault?: boolean;

  // Cloud printers / KDS
  cloudPrintersEnabled?: boolean;
  cloudPrintersEnabledDefault?: boolean;
  cloudPrintersEnabledSendToKitchen?: boolean;
  sendToKitchenKDS?: boolean; // maps to SendToKitchenKDS in Java

  // Other toggles
  offlinePOS?: boolean;
  serviceBased?: boolean;
  /**
   * Shop or food business — "E-commerce (sells products, not food)" in the
   * vendor portal. Three-state: true/false is the vendor's answer and wins;
   * undefined means nobody has said, and the storefront infers it from the
   * service flags. See isShopStore() in
   * customer/store-experience/store-experience.copy.ts.
   */
  ecommerceEnabled?: boolean;
  customerDisplay?: boolean;
  tableOrdering?: boolean;
  tableReservation?: boolean;
  serviceReservation?: boolean;

  // Reservations config
  reservationIntervals?: number;
  /** Store-wide default gap (minutes) kept free after each service booking. */
  serviceBufferMinutes?: number;
  reservationsFull?: boolean;
  barber?: boolean;
  addonServices?: boolean;

  // Break timings
  breakTimingJson?: Array<{
    day: string;
    closingTime: string;
    reOpeningTime: string;
  }>;

  // Discount / misc
  freeDeliveryAmount?: number;
  /** Delivery is flat-rate postal shipping, not a Stuart courier. See shop-mode.ts. */
  postalShippingEnabled?: boolean;
  shippingFlatFee?: number;
  /** Option.stockQty is a real per-size/colour stock count. */
  variantStockEnabled?: boolean;
  /** Customers may upload artwork on items marked for it (ecommerce stores). */
  customerArtworkEnabled?: boolean | null;
  maxStoreWidePOSDiscount?: number;
  discountValueInterval?: number;
  autoAcceptOnlineOrders?: boolean;
  autoPrintOnlineOrders?: boolean;

  notificationSoundDuration?: number;

    
  notificationSoundPlayTillDialogue?: boolean;

   
  DPOSItemImages?: boolean;

  deviceType?: number;

  rewardsType?: number;

  enableCloseCartSTK?: boolean;

  paymentProcessor?: number;
  cateringPrepTime?: number;
  storeOptionsOpened?: boolean;
  selfServiceKIOSK?: boolean;
  reservationsByCapacity?: boolean;
  reservationCapacity?: number;
  reservationsBookingInterval?: number;
  /** How many days ahead a normal booking may be made. Null/0 = default (7 for barber stores, else unlimited). */
  reservationMaxDaysAhead?: number | null;
  /** "Book again" choices, as a comma list of weeks, e.g. "2,3,4,6". Null = 2,3,4,6. */
  rebookWeekOptions?: string | null;
  /** The highlighted "Book again" choice, in weeks. Null = 3 (or the first option). */
  rebookDefaultWeeks?: number | null;
  // Audit
  createdBy?: number;
  createdOn?: string;
  modifiedBy?: number;
  modifiedOn?: string;
}
export interface TeyaCheckoutSessionRequest {
    amount: {
      currency: string;  // "USD"
      value: number;     // 100
    };
    billing_address?: {
      city?: string;
      country?: string; // "GB"
      state?: string;
      street_address_line1?: string;
      street_address_line2?: string;
      street_address_line3?: string;
      zipcode?: string;
    };
    cancel_url: string;
    customer?: {
      email?: string;
      name?: string;
      phone_number?: string;
    };
    customer_success_email?: string;
    failure_url: string;
    language?: string; // backend sets it, can omit
    line_items?: Array<{
      description: string;
      quantity: number;
      unit_price: number;
    }>;
    merchant_reference?: string; // backend sets from orderId, can omit
    merchant_success_email?: string;
    metadata?: Record<string, any>;
    post_success_payment?: string; // backend sets it, can omit
    store_id: string; // IMPORTANT: Teya Store UUID
    success_url: string;
    type?: string; // backend sets it, can omit
  }  
export interface ReservationTiming {
    day: string;         // e.g. "MONDAY"
    openingTime: string; // "10:00"
    closingTime: string; // "22:00"
  }
  
  export interface ClosedPeriod {
    startDate: string; // "2026-02-15"
    endDate: string;   // "2026-02-20"
    reason?: string;
    recurring: boolean; // NEW

  }
  
  export interface ReservationSettings {
    id?: number;
    businessId?: number;
    storeId?: number;
    serviceProviderId?:number;
    reservationTimings: ReservationTiming[];
    closedPeriods: ClosedPeriod[];
  }
  export interface RewardItem {
    id?: number;
    businessId?: number;
    userId?: number;
    name?: string;
    description?: string;
    stampsRequired?: number;
    pointsRequired?: number;
    storeItem?: any;
    [key: string]: any;
  }
  
  export interface RewardsOverviewResponse {
    userPoints: number;
    rewardItems: RewardItem[];
  }
  
  export interface ApiStatusResponse {
    status: string;
    message: string;
  }
  
  export interface RewardsSettings {
    id?: number;
    businessId: number;
    rewardRatio: number;
    [key: string]: any;
  }
  export class AddPoints{
    userId: number = -1;
    businessId: number = -1;
    storeId:number = -1;
    tempOrderId: number = -1;
  }
  
}
